<template>
    <div id="system_site">
        <el-form ref="form" :model="form"
                 :label-width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'100px':'300px'"
                 size="small">
            <el-form-item label="观看视频次数"
                          :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                <el-input v-model="form.watch_video_times"
                          :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
            </el-form-item>
            <el-form-item label="观看视频金币"
                          :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                <el-input v-model="form.watch_video_coin"
                          :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>

    export default {
        name: "system_site",
        data() {
            return {
                form: {
                    watch_video_times: '',
                    watch_video_coin: ''
                },
            }
        },
        created() {
            this.getData()
        },
        methods: {
            onSubmit() {
                this.$axios.post('admin/config/ad_set', {config: this.form}).then((res) => {
                    this.$message.success('成功');
                    this.getData();
                });
            },
            getData() {
                this.$axios.post('admin/config/ad').then((res) => {
                    this.form = res.data;
                });
            },

        }
    }
</script>

<style scoped lang="scss">

</style>